import { IntlProvider } from 'react-intl';
import locale from '../locales';

const { intl } = new IntlProvider(locale, {}).getChildContext();
export default intl;
